import { SelectModalM } from "@common/components/select/selectSingle-Multiple"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { padToTwo } from "@data/utility/Utils"
import React, { useState } from "react"
import { ScrollView, TouchableOpacity, View } from "react-native"
import { Checkbox, IconButton } from "react-native-paper"
import {
    availabilityOptions,
    dateOptions,
} from "../../../data/constants/formConstants"
import { SwitchComponent } from "../../../tutor/application/personalInfos/ApplicationPersonalInfos"
import FilledButtonM from "../button/FilledButtonM"
import { ModalM } from "../modal/ModalM"
import SelectRangeModalM from "./SelectRangeModalM"

export const SelectDateTime = ({
    modalVisible,
    setModalVisible,
    title,
    formValues,
    setFormValues,
    currentFieldName,
    onFinishSelecting,
    optionalField = null,
    onOptionSelect = () => {},
}) => {
    const [selectedDate, setSelectedDate] = useState(null)
    const [selectedDateValue, setSelectedDateValue] = useState(null)
    const [time, setTime] = useState("14:00")

    const currentValue = formValues?.[currentFieldName] ?? []

    const options = Array.from({ length: 25 }, (_, i) => {
        const hour = Math.floor(i / 2) + 9
        const minute = i % 2 === 0 ? "00" : "30"
        return {
            label: padToTwo(hour) + ":" + padToTwo(minute),
            value: padToTwo(hour) + ":" + padToTwo(minute),
        }
    })

    return (
        <ModalM
            style={{
                justifyContent: "center",
                alignItems: "center",
                height: "95%",
                width: "100%",
            }}
            visible={modalVisible}
            onDismiss={() => {
                setModalVisible(false)
                onFinishSelecting()
            }}
        >
            <IconButton
                icon="times"
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                style={{
                    alignSelf: "flex-start",
                }}
                size={32}
                onPress={() => {
                    setModalVisible(!modalVisible)
                    onFinishSelecting()
                }}
            />

            <View
                style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: "100%",
                    paddingHorizontal: 20,
                }}
            >
                <TextM
                    fontSize={22}
                    fontWeight="Bold"
                    color={theme.colors.primary}
                    style={{
                        flex: 1,
                    }}
                    wrap
                >
                    {title}
                </TextM>

                {optionalField && (
                    <View
                        style={{
                            flexDirection: "row",
                            alignItems: "center",
                            justifyContent: "flex-start",
                        }}
                    >
                        <TextM
                            fontSize={16}
                            fontWeight={"Bold"}
                            color={theme.colors.primary}
                            style={{
                                flex: 1,
                            }}
                            wrap
                        >
                            {optionalField?.label}
                        </TextM>
                        <Checkbox
                            status={
                                formValues?.[optionalField?.name]
                                    ? "checked"
                                    : "unchecked"
                            }
                            onPress={() => {
                                onOptionSelect(
                                    optionalField?.name,
                                    !formValues?.[optionalField?.name]
                                )
                            }}
                            color={theme.colors.primary}
                            uncheckedColor={theme.colors.primary}
                            style={{
                                borderWidth: 1,
                                borderRadius: 16,
                                borderColor: theme.colors.lightMore,
                            }}
                        />
                    </View>
                )}
            </View>

            <View
                style={{
                    flex: 1,
                    marginTop: 5,
                    backgroundColor: theme.colors.white,
                    paddingHorizontal: 20,
                }}
            >
                <ScrollView
                    style={{
                        width: "100%",
                        paddingHorizontal: 20,
                    }}
                >
                    {dateOptions.map(({ label, value }) => {
                        const isDaySelected = currentValue?.some(
                            (x) => x?.split(" ")[0] === value
                        )
                        const daySelectedTime = currentValue
                            ?.find((x) => x?.split(" ")[0] === value)
                            ?.split(" ")[1]

                        return (
                            <SwitchComponent
                                key={value}
                                value={isDaySelected}
                                setValue={(isSelected) => {
                                    if (isSelected) {
                                        setFormValues({
                                            ...formValues,
                                            [currentFieldName]: [
                                                ...(currentValue || []),
                                                value + " " + time,
                                            ],
                                        })
                                        setSelectedDate(label)
                                        setSelectedDateValue(value)
                                    } else {
                                        const newValues = currentValue?.filter(
                                            (x) => x.split(" ")[0] !== value
                                        )
                                        setFormValues({
                                            ...formValues,
                                            [currentFieldName]: newValues,
                                        })
                                    }
                                }}
                                label={label}
                                renderAdditionalComponent={() =>
                                    isDaySelected && (
                                        <TouchableOpacity
                                            onPress={() => {
                                                setSelectedDate(label)
                                                setSelectedDateValue(value)
                                            }}
                                        >
                                            <View
                                                style={{
                                                    paddingHorizontal: 10,
                                                    width: "100%",
                                                }}
                                            >
                                                <TextM
                                                    color={theme.colors.grey}
                                                >
                                                    à partir de{" "}
                                                    <TextM
                                                        fontWeight="Bold"
                                                        style={{
                                                            textDecorationLine:
                                                                "underline",
                                                        }}
                                                        color={
                                                            theme.colors.link
                                                        }
                                                    >
                                                        {daySelectedTime}
                                                    </TextM>
                                                </TextM>
                                            </View>
                                        </TouchableOpacity>
                                    )
                                }
                            />
                        )
                    })}
                </ScrollView>
            </View>

            <FilledButtonM
                style={{
                    marginRight: 20,
                    marginLeft: 20,
                    marginBottom: 70,
                    marginTop: 20,
                    width: "90%",
                }}
                onPress={() => {
                    setModalVisible(false)
                    onFinishSelecting()
                }}
                label="Terminer"
            />

            {selectedDateValue && (
                <SelectModalM
                    isMulti={false}
                    modalVisible={!!selectedDateValue}
                    setModalVisible={() => setSelectedDateValue(null)}
                    title={`${selectedDate} à partir de`}
                    selectedValue={time}
                    options={options}
                    valueMode={true}
                    onSingleSelect={(value) => {
                        setTime(value.value)
                        const newValues = currentValue?.map((x) =>
                            x?.split(" ")[0] === selectedDateValue
                                ? selectedDateValue + " " + value.value
                                : x
                        )
                        setFormValues({
                            ...formValues,
                            [currentFieldName]: newValues,
                        })
                        setSelectedDate(null)
                        setSelectedDateValue(null)
                    }}
                    itemHeight={50}
                />
            )}
        </ModalM>
    )
}

export const SelectDateTimeRange = ({
    modalVisible,
    setModalVisible,
    title,
    formValues,
    setFormValues,
    currentFieldName,
    onFinishSelecting,
    handleRangeSelect,
    rangeTitle = "Sélectionner les horaires min recherchés",
}) => {
    const [selectedDate, setSelectedDate] = useState(null)
    const [selectedDateValue, setSelectedDateValue] = useState(null)
    const [timeRangeModalVisible, setTimeRangeModalVisible] = useState(false)

    const currentValue = formValues?.[currentFieldName] ?? []

    const options = Array.from({ length: 25 }, (_, i) => {
        const hour = Math.floor(i / 2) + 9
        const minute = i % 2 === 0 ? "00" : "30"
        return {
            label: padToTwo(hour) + ":" + padToTwo(minute),
            value: padToTwo(hour) + ":" + padToTwo(minute),
        }
    })

    return (
        <ModalM
            style={{
                justifyContent: "center",
                alignItems: "center",
                height: "95%",
                width: "100%",
            }}
            visible={modalVisible}
            onDismiss={() => {
                setModalVisible(false)
                onFinishSelecting()
            }}
        >
            <IconButton
                icon="times"
                iconColor={theme.colors.primary}
                containerColor={theme.colors.transparent}
                style={{
                    alignSelf: "flex-start",
                }}
                size={32}
                onPress={() => {
                    setModalVisible(!modalVisible)
                    onFinishSelecting()
                }}
            />

            <View
                style={{
                    flexDirection: "row",
                    alignItems: "flex-start",
                    justifyContent: "space-between",
                    width: "100%",
                    paddingHorizontal: 20,
                }}
            >
                <TextM
                    fontSize={22}
                    fontWeight="Bold"
                    color={theme.colors.primary}
                    style={{
                        flex: 1,
                    }}
                    wrap
                >
                    {title}
                </TextM>
                <TextM
                    fontSize={16}
                    fontWeight="SemiBold"
                    color={theme.colors.primary}
                    style={{
                        flex: 1,
                        textDecorationLine: "underline",
                    }}
                    onPress={() => {
                        setFormValues({
                            ...formValues,
                            [currentFieldName]: [],
                        })
                    }}
                >
                    Réinitialiser
                </TextM>
            </View>

            <View
                style={{
                    flex: 1,
                    marginTop: 5,
                    backgroundColor: theme.colors.white,
                    paddingHorizontal: 20,
                }}
            >
                <ScrollView
                    style={{
                        width: "100%",
                        paddingHorizontal: 20,
                    }}
                >
                    {availabilityOptions.map(({ label, value }) => {
                        const isDaySelected = currentValue?.some(
                            (x) => x?.split(" ")[0] === value
                        )
                        const timeRange =
                            currentValue
                                ?.find((x) => x?.split(" ")[0] === value)
                                ?.split(" ")[1] || ""

                        let timeStart = ""
                        let timeEnd = ""

                        if (timeRange?.includes("-")) {
                            const splitRange = timeRange.split("-")
                            timeStart = splitRange[0]
                            timeEnd = splitRange[1]
                        }

                        return (
                            <SwitchComponent
                                key={value}
                                value={isDaySelected}
                                setValue={(isSelected) => {
                                    if (isSelected) {
                                        setSelectedDate(label)
                                        setSelectedDateValue(value)
                                        setTimeRangeModalVisible(true)
                                    } else {
                                        const newValues = currentValue?.filter(
                                            (x) => x.split(" ")[0] !== value
                                        )
                                        setFormValues({
                                            ...formValues,
                                            [currentFieldName]: newValues,
                                        })
                                    }
                                }}
                                label={label}
                                renderAdditionalComponent={() =>
                                    isDaySelected && (
                                        <TouchableOpacity
                                            onPress={() => {
                                                setSelectedDate(label)
                                                setSelectedDateValue(value)
                                                setTimeRangeModalVisible(true)
                                            }}
                                        >
                                            <View
                                                style={{
                                                    paddingHorizontal: 10,
                                                    width: "100%",
                                                }}
                                            >
                                                <TextM
                                                    color={theme.colors.grey}
                                                >
                                                    <TextM
                                                        fontWeight="Bold"
                                                        style={{
                                                            textDecorationLine:
                                                                "underline",
                                                        }}
                                                        color={
                                                            theme.colors.link
                                                        }
                                                    >
                                                        {timeStart && timeEnd
                                                            ? `${timeStart} - ${timeEnd}`
                                                            : "Sélectionner une plage horaire"}
                                                    </TextM>
                                                </TextM>
                                            </View>
                                        </TouchableOpacity>
                                    )
                                }
                            />
                        )
                    })}
                </ScrollView>
            </View>

            <FilledButtonM
                style={{
                    marginRight: 20,
                    marginLeft: 20,
                    marginBottom: 70,
                    marginTop: 20,
                    width: "90%",
                }}
                onPress={() => {
                    setModalVisible(false)
                    onFinishSelecting()
                }}
                label="Terminer"
            />

            {selectedDateValue && (
                <SelectRangeModalM
                    modalVisible={timeRangeModalVisible}
                    setModalVisible={setTimeRangeModalVisible}
                    title={`${selectedDate} : ${rangeTitle}`}
                    options={options}
                    selectedValues={(() => {
                        const dayTimeRange =
                            currentValue
                                ?.find(
                                    (x) =>
                                        x?.split(" ")[0] === selectedDateValue
                                )
                                ?.split(" ")[1] || ""

                        let start = ""
                        let end = ""

                        if (dayTimeRange && dayTimeRange.includes("-")) {
                            const splitRange = dayTimeRange.split("-")
                            start = splitRange[0]
                            end = splitRange[1]

                            return options
                                .filter(
                                    (opt) =>
                                        opt.value >= start && opt.value <= end
                                )
                                .map((opt) => opt.value)
                        }

                        return []
                    })()}
                    onRangeSelect={(rangeValues) =>
                        handleRangeSelect(
                            rangeValues,
                            currentValue,
                            selectedDateValue,
                            formValues,
                            currentFieldName
                        )
                    }
                    itemHeight={50}
                    onFinishSelecting={() => {
                        setTimeRangeModalVisible(false)
                    }}
                />
            )}
        </ModalM>
    )
}
